export const defaultOption = {
    default: '',
    target: ['paragraph'],
    options: [
        {
            label: '不缩进',
            value: '',
        },
        {
            label: '2字符',
            value: '2em',
        },
        {
            label: '4字符',
            value: '4em',
        },
        {
            label: '8字符',
            value: '8em',
        },
    ],
};
//# sourceMappingURL=data.js.map